<template>
    <section class="w-full">
        <div class="relative flex flex-col py-12 justify-center items-center">
            <h1 class="text-3xl text-center leading-10 mb-8 font-medium">Hoi <span class="text-[#46A7B3] font-bold usergroup_txt" v-if="user">{{user.first_name}}</span><span class="text-[#46A7B3] font-bold usergroup_txt">,</span><br/>Waarmee kan ik je helpen?</h1>
            <searchbar :supersearch="false"></searchbar>
        </div>
        <StatusBanner />
        <div id="quicklinks" class="flex flex-row flex-wrap mb-9">
            <a :href="ql.url" target="_blank" class="flex flex-row w-6/12 h-fit py-6 px-8 bg-backgroundgrey rounded-lg mb-3 odd:mr-3 odd:w-[calc(50%-0.75rem)]" v-for="(ql, index) in quicklinks" :key="index">
                <div class="flex w-11 h-11 mr-8 items-center justify-center usergroup_bg rounded-full">
                    <img :src="ql.logo" class="w-6/12 rounded-none" />
                </div>
                <div class="flex flex-col justify-center flex-grow">
                    <span class="text-sm font-bold">{{ql.title}}</span>
                </div>
            </a>
            <!-- <a href="/" class="flex flex-row w-6/12 py-6 px-8 bg-backgroundgrey rounded-lg">
                <div class="flex w-11 h-11 mr-8 items-center justify-center bg-dstnygreen rounded-full">
                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" class="flex-grow-0 flex-shrink-0 w-8 h-8 relative" preserveAspectRatio="none">
                        <path d="M24.5714 24.0001V23.5001V24.0001ZM8.42857 24.0001V24.5001V24.0001ZM24.5714 21.1429V21.6429V21.1429ZM8.42857 21.1429V20.6429V21.1429ZM7 22.5715H7.5H7ZM24.5925 11H24.0925H24.5925ZM24.0925 21.1429C24.0925 21.419 24.3164 21.6429 24.5925 21.6429C24.8687 21.6429 25.0925 21.419 25.0925 21.1429H24.0925ZM8.40734 11H8.90734H8.40734ZM7.90734 21.1429C7.90734 21.419 8.1312 21.6429 8.40734 21.6429C8.68349 21.6429 8.90734 21.419 8.90734 21.1429H7.90734ZM22.5925 9L22.5925 9.5L22.5925 9ZM10.4073 9.00001L10.4073 8.50001L10.4073 9.00001ZM24.5714 23.5001H8.42857V24.5001H24.5714V23.5001ZM24.5714 20.6429L8.42857 20.6429V21.6429L24.5714 21.6429V20.6429ZM26.5 22.5715C26.5 21.5064 25.6365 20.6429 24.5714 20.6429V21.6429C25.0843 21.6429 25.5 22.0587 25.5 22.5715H26.5ZM7.5 22.5715C7.5 22.0587 7.91574 21.6429 8.42857 21.6429V20.6429C7.36345 20.6429 6.5 21.5064 6.5 22.5715H7.5ZM8.42857 23.5001C7.91574 23.5001 7.5 23.0844 7.5 22.5715H6.5C6.5 23.6366 7.36345 24.5001 8.42857 24.5001V23.5001ZM24.5714 24.5001C25.6365 24.5001 26.5 23.6366 26.5 22.5715H25.5C25.5 23.0844 25.0843 23.5001 24.5714 23.5001V24.5001ZM24.0925 11V21.1429H25.0925V11H24.0925ZM7.90734 11L7.90734 21.1429H8.90734L8.90734 11H7.90734ZM22.5925 8.5L10.4073 8.50001L10.4073 9.50001L22.5925 9.5L22.5925 8.5ZM25.0925 11C25.0925 9.61929 23.9732 8.5 22.5925 8.5L22.5925 9.5C23.421 9.5 24.0925 10.1716 24.0925 11H25.0925ZM8.90734 11C8.90734 10.1716 9.57892 9.50001 10.4073 9.50001L10.4073 8.50001C9.02663 8.50001 7.90734 9.6193 7.90734 11H8.90734Z" fill="white"></path>
                    </svg>
                </div>
                <div class="flex flex-col justify-center">
                    <span class="text-sm font-bold">Paris Tech center</span>
                    <span class="text-xs text-[#999CA0]">Provision al of your clients with ease and scalability</span>
                </div>
            </a> -->
        </div>
        <div class="flex flex-row flex-wrap gap-7 mb-6 md:flex-nowrap">
            <!-- <div class="flex flex-row w-full h-fit p-4 bg-backgroundgrey rounded-lg md:w-6/12">
                <div class="flex flex-col w-full p-4 bg-[#ffffff] rounded-lg">
                    <h2 class="text-lg mb-3 font-bold">Jouw ticketupdates</h2>
                    <div class="flex w-full">
                        <div class="flex align-middle justify-center w-6/12 py-12">
                            <span class="flex justify-center items-center bg-[rgba(70,167,179,0.12)] w-16 h-16 rounded-full">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 mr-3 relative" :class="drawerOpen ? '' : 'mr-0'" preserveAspectRatio="none">
                                    <path d="M8.94884 4.79818C13.8479 4.2829 19.5573 4.53079 23.0639 4.82934C24.3686 4.94043 25.3898 5.97252 25.5048 7.27555C25.9562 12.394 26.3815 20.5595 25.422 27.5794C25.327 28.2743 24.5055 28.5729 23.9828 28.1227L22.3038 26.6766C22.2113 26.597 22.0771 26.5927 21.9799 26.666L19.8826 28.2465C19.4341 28.5845 18.8168 28.5845 18.3683 28.2465L16.2393 26.6421C16.1471 26.5726 16.0209 26.5726 15.9287 26.6421L13.7996 28.2465C13.3511 28.5845 12.7338 28.5845 12.2853 28.2465L10.188 26.666C10.0909 26.5927 9.95661 26.597 9.86417 26.6766L8.17762 28.1292C7.65766 28.577 6.8436 28.284 6.73909 27.5981C5.52111 19.6044 6.04928 11.819 6.61652 7.1109C6.76371 5.88924 7.72115 4.92731 8.94884 4.79818ZM22.979 5.82574C19.4995 5.52948 13.8616 5.28697 9.05344 5.7927C8.29819 5.87213 7.70177 6.46336 7.60934 7.23052C7.05285 11.8494 6.5385 19.4346 7.69434 27.2257L9.21159 25.9189C9.66033 25.5324 10.3168 25.5109 10.7899 25.8674L12.8872 27.4479L12.5863 27.8472L12.8872 27.4479C12.9794 27.5174 13.1056 27.5174 13.1978 27.4479L13.4987 27.8472L13.1978 27.4479L15.3268 25.8434C15.7753 25.5054 16.3926 25.5054 16.8411 25.8434L18.9702 27.4479C19.0624 27.5174 19.1886 27.5174 19.2808 27.4479L21.3781 25.8674C21.8511 25.5109 22.5076 25.5325 22.9564 25.9189L24.4619 27.2156C25.3659 20.3608 24.9535 12.4071 24.5086 7.36341C24.4358 6.53798 23.7932 5.89506 22.979 5.82574ZM9.50099 10.6184C9.50099 10.3423 9.72484 10.1184 10.001 10.1184H15.7038C15.9799 10.1184 16.2038 10.3423 16.2038 10.6184C16.2038 10.8946 15.9799 11.1184 15.7038 11.1184H10.001C9.72484 11.1184 9.50099 10.8946 9.50099 10.6184ZM9.50099 15.2026C9.50099 14.9264 9.72484 14.7026 10.001 14.7026H22.167C22.4431 14.7026 22.667 14.9264 22.667 15.2026C22.667 15.4787 22.4431 15.7026 22.167 15.7026H10.001C9.72484 15.7026 9.50099 15.4787 9.50099 15.2026ZM9.50099 19.7867C9.50099 19.5106 9.72484 19.2867 10.001 19.2867H22.167C22.4431 19.2867 22.667 19.5106 22.667 19.7867C22.667 20.0629 22.4431 20.2867 22.167 20.2867H10.001C9.72484 20.2867 9.50099 20.0629 9.50099 19.7867Z" fill="black"></path>
                                </svg>
                            </span>
                        </div>
                        <div class="flex flex-col align-middle justify-center items-center w-6/12 py-12">
                            <span class="text-5xl text-[#000] font-extrabold mb-5">{{ mijnTotalTickets }}</span>
                            <span class="text-[8px] uppercase font-bold">aantal tickets</span>
                        </div>
                    </div>
                    <router-link class="group w-40 flex flex-row justify-between items-center text-sm" :to="{
                        name: 'Ticketoverzicht',
                        params: {
                            tab: 'mijntickets',
                        }
                    }">
                        <span class="transition-all ease-in-out group-hover:text-[#000000]">Ga naar jouw tickets</span> 
                        <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="transition-all ease-in-out group-hover:translate-x-1" preserveAspectRatio="xMidYMid meet"><path class="transition-all ease-in-out group-hover:stroke-black" d="M5.75 5.25L10.25 12L5.75 18.75" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    </router-link>
                </div>
            </div> -->
            <div class="flex flex-row w-full h-fit p-4 bg-backgroundgrey rounded-lg md:w-3/12">
                <div class="flex flex-col w-full p-4 bg-[#ffffff] rounded-lg">
                    <h2 class="text-lg mb-3 font-bold">Nieuw ticket</h2>
                    <a class="flex flex-row w-fit my-[4.4rem] button self-center" href="https://destinygroup.atlassian.net/servicedesk/customer/portal/58" target="_blank">
                        Ticket in Jira
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 ml-3 relative stroke-[#ffffff] fill-[#ffffff]" :class="drawerOpen ? '' : 'mr-0'" preserveAspectRatio="none">
                            <path d="M8.94884 4.79818C13.8479 4.2829 19.5573 4.53079 23.0639 4.82934C24.3686 4.94043 25.3898 5.97252 25.5048 7.27555C25.9562 12.394 26.3815 20.5595 25.422 27.5794C25.327 28.2743 24.5055 28.5729 23.9828 28.1227L22.3038 26.6766C22.2113 26.597 22.0771 26.5927 21.9799 26.666L19.8826 28.2465C19.4341 28.5845 18.8168 28.5845 18.3683 28.2465L16.2393 26.6421C16.1471 26.5726 16.0209 26.5726 15.9287 26.6421L13.7996 28.2465C13.3511 28.5845 12.7338 28.5845 12.2853 28.2465L10.188 26.666C10.0909 26.5927 9.95661 26.597 9.86417 26.6766L8.17762 28.1292C7.65766 28.577 6.8436 28.284 6.73909 27.5981C5.52111 19.6044 6.04928 11.819 6.61652 7.1109C6.76371 5.88924 7.72115 4.92731 8.94884 4.79818ZM22.979 5.82574C19.4995 5.52948 13.8616 5.28697 9.05344 5.7927C8.29819 5.87213 7.70177 6.46336 7.60934 7.23052C7.05285 11.8494 6.5385 19.4346 7.69434 27.2257L9.21159 25.9189C9.66033 25.5324 10.3168 25.5109 10.7899 25.8674L12.8872 27.4479L12.5863 27.8472L12.8872 27.4479C12.9794 27.5174 13.1056 27.5174 13.1978 27.4479L13.4987 27.8472L13.1978 27.4479L15.3268 25.8434C15.7753 25.5054 16.3926 25.5054 16.8411 25.8434L18.9702 27.4479C19.0624 27.5174 19.1886 27.5174 19.2808 27.4479L21.3781 25.8674C21.8511 25.5109 22.5076 25.5325 22.9564 25.9189L24.4619 27.2156C25.3659 20.3608 24.9535 12.4071 24.5086 7.36341C24.4358 6.53798 23.7932 5.89506 22.979 5.82574ZM9.50099 10.6184C9.50099 10.3423 9.72484 10.1184 10.001 10.1184H15.7038C15.9799 10.1184 16.2038 10.3423 16.2038 10.6184C16.2038 10.8946 15.9799 11.1184 15.7038 11.1184H10.001C9.72484 11.1184 9.50099 10.8946 9.50099 10.6184ZM9.50099 15.2026C9.50099 14.9264 9.72484 14.7026 10.001 14.7026H22.167C22.4431 14.7026 22.667 14.9264 22.667 15.2026C22.667 15.4787 22.4431 15.7026 22.167 15.7026H10.001C9.72484 15.7026 9.50099 15.4787 9.50099 15.2026ZM9.50099 19.7867C9.50099 19.5106 9.72484 19.2867 10.001 19.2867H22.167C22.4431 19.2867 22.667 19.5106 22.667 19.7867C22.667 20.0629 22.4431 20.2867 22.167 20.2867H10.001C9.72484 20.2867 9.50099 20.0629 9.50099 19.7867Z" fill="black"></path>
                        </svg>
                    </a>
                </div>
            </div>
            <div class="flex flex-row w-full h-fit md:w-6/12"></div>
            <div class="flex w-full p-4 bg-backgroundgrey rounded-lg md:w-3/12">
                <div class="flex flex-col p-4 bg-[#ffffff] rounded-lg md:w-full">
                    <h2 class="text-lg mb-3 font-bold">Nieuwste berichten</h2>
                    <router-link v-for="bericht in berichten" :key="bericht.id" class="flex flex-row py-2 my-3" :to="{
                        name: 'Bericht',
                        params: {
                            berichtSlug: bericht.slug,
                            berichtId: bericht.ID,
                            berichtCat: '',
                            berichtCatName: ''
                        }
                    }">
                        <div class="mr-3">
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2 stroke-blueberryfaygo usergroup_svg_stroke" preserveAspectRatio="xMidYMid meet">
                                <path d="M14.615 5.32989C15.1274 4.09796 16.8726 4.09795 17.385 5.32989L19.3512 10.0573C19.5672 10.5766 20.0556 10.9315 20.6163 10.9764L25.7199 11.3856C27.0499 11.4922 27.5892 13.1519 26.5759 14.0199L22.6875 17.3508C22.2603 17.7167 22.0737 18.2909 22.2042 18.838L23.3922 23.8182C23.7018 25.1161 22.2899 26.1419 21.1513 25.4464L16.7819 22.7776C16.3019 22.4844 15.6981 22.4844 15.2181 22.7776L10.8487 25.4464C9.71009 26.1419 8.29821 25.1161 8.6078 23.8182L9.79576 18.838C9.92627 18.2909 9.73972 17.7167 9.31253 17.3508L5.42414 14.02C4.41084 13.1519 4.95013 11.4922 6.28011 11.3856L11.3837 10.9764C11.9444 10.9315 12.4328 10.5766 12.6488 10.0573L14.615 5.32989Z"></path>
                            </svg>
                        </div>
                        <div class="flex flex-col text-[#999CA0]">
                            <span v-html="bericht.post_title" class="text-sm text-blueberryfaygo font-bold usergroup_txt"></span>
                            <span class="text-xxs text-greyghost font-semibold">Laatst gewijzigd - {{formatDate(bericht.post_modified)}}</span>
                            <span v-html="bericht.post_excerpt.substring(0,50)+'...'" class="text-xs"></span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- <div class="flex flex-col w-full p-4 bg-backgroundgrey rounded-lg">
            <div class="flex flex-col w-full p-4 bg-[#ffffff] rounded-lg">
                    <h2 class="text-lg mb-3">Onlangs bekeken artikelen</h2>
            </div>
        </div> -->
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import StatusBanner from '@/components/LiveStatus/StatusBanner.vue';
import Searchbar from '@/components/Searchbar.vue';

export default {
    name: 'HomeView',
    components: {
       
        
        StatusBanner,
        Searchbar
    },
    data() {
        return {
            isActive: false,
            berichten: [],
            searchTerm: "",
            articleResults: [],
            nieuwsResults: [],
            ticketResults: [],
            searched: false,
            hoverResults: false,
            quicklinks: [],
            hasSearched: false,
            oeps: false,
            timeout: null,
            loading: false,
            mijnTotalTickets: 0
        }
    },
    created() {
        console.log(this.user);
        this.getBerichten()
        this.getQuicklinks()
        this.getMijnTickets()
        this.$store.commit('setDisableSupersearch', false);
    },
    computed: {
        ...mapGetters(["user","usergroup","accountId"])
    },
    methods: {
        getBerichten() {

            var date = new Date();
            date.setDate(date.getDate()-21);
            date = date.toISOString();

            this.$axios.get('/api/wp-json/paris/v1/front-end/generic/search/post?pql={posts_per_page=5;meta_query=[[key=zichtbaar_voor,value='+this.usergroup.id+',compare=LIKE]]}').then(response => (
                this.berichten = response.data
                // console.log(response.data)
            ))
            
        },
        getQuicklinks() {
            const cacheBuster = (url) => `${url}?cb=${Date.now()}`;
            this.$axios.get(cacheBuster('/api/wp-json/paris/v1/front-end/user/quicklinks'), {
                params: {
                    userId: this.user.user_id,
                    usergroupId: this.usergroup.id
                }
            }).then(response => (
                this.quicklinks = response.data
            ));

        },
        getMijnTickets() {

            this.$axios.get('/api/wp-json/paris/v1/front-end/usergroup/labels', {
                params: {
                    usergroup_id: this.usergroup.id
                }
            }).then(response => {

                this.labels = response.data;
                
            })

            const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

            this.$axios.get(cacheBuster('/api/wp-json/paris/v1/search'), {
                params: {
                    maxResults: 500,
                    jql: 'reporter='+this.accountId+'%26status%20NOT%20IN%20(\'closed\',\'resolved\')',
                    expand: 'renderedFields'
                }
            }).then(response => {
                this.mijnTotalTickets = response.data.issues.length;
            });
        },
        openCreateTicket() {
            console.log(this.$root.$refs.RightSidebar);
            this.$store.commit('setDisableSupersearch', false);
            // this.$root.$refs.RightSidebar.ticketform.changeLayer(1,1);
            // this.$root.$refs.RightSidebar.createTicketOpen = true;
            this.$root.$refs.RightSidebar.toggleSideBar();
            this.$root.$refs.RightSidebar.createTicket();
        },
        timeResultHover() {

            if(this.hoverResults == true) {
                this.isActive = true;
            } else {
                this.isActive = false;
            }
        },
    }
}
</script>